import * as React from 'react';

interface IProps {
    branchName: string;
}

export class BranchMerge extends React.Component<IProps, any> {

    render() {

        let { branchName } = this.props;

        return null;

        // return <div className='component ui-only in-branch'>
        //     <span className="branch-badge badge-circle badge-bottom" title="Merging decision branches">
        //         <i className="ms-Icon ms-Icon--Merge" aria-hidden="true"></i>
        //     </span>
        //     <div className="component-summary component-inner">
        //         <span>End of Decision</span>
        //     </div>
        // </div>;

    }

}



// WEBPACK FOOTER //
// ./source/ts/components/components/branch-merge.tsx